import { StatementsData } from './types'
import client from '../../client'

export const getAllStatements = () => client.get<StatementsData>('v1/user/statement')
